export default __webpack_public_path__ + "static/media/sofia_m.08914c1c.jpg";